import { createInstance as createAmplitudeInstance } from '@amplitude/analytics-browser';
import { gaEventsForwarderPlugin } from '@amplitude/plugin-ga-events-forwarder-browser';
import { captureException } from '@sentry/react';
import { useEffect } from 'react';
import { AnalyticsProvider } from 'use-analytics';
import analytics from './analytics';

const AmplitudeSetup = () => {
	useEffect(() => {
		// Set up Google Analytics event forwarding to Amplitude
		if (import.meta.env.PUBLIC_ENV__ANALYTICS_ENABLED === 'true' && import.meta.env.PUBLIC_ENV__AMPLITUDE_ENABLED === 'true') {
			const amplitude = createAmplitudeInstance();
			const AMPLITUDE_API_KEY = import.meta.env.PUBLIC_ENV__AMPLITUDE_API_KEY;
			try {
				amplitude.add(gaEventsForwarderPlugin());
				amplitude.init(AMPLITUDE_API_KEY, {
					autocapture: false,
				});
			} catch (err) {
				captureException(err, {
					level: 'info',
					extra: { isAnalyticsException: true },
				});
			}
		}
	}, []);

	return null;
};

export const ZalaAnalyticsProvider = ({ children }: { children: React.ReactNode }) => (
	<>
		<AmplitudeSetup />
		<AnalyticsProvider instance={analytics}>{children}</AnalyticsProvider>
	</>
);
